import type { ReactNode } from 'react';
import Box from '@/modules/components/Box/Box';
import { Spinner } from '@tribal-worldwide-london/ui-component-library-vwg';

interface FallbackSpinnerProps {
  children?: ReactNode;
}

const FallbackSpinner = ({ children }: FallbackSpinnerProps) => (
  <Box
    height="100vh"
    width="100%"
    display="flex"
    alignItems="center"
    justifyContent="center"
    flexDirection="column"
  >
    {children && (
      <Box display="flex" justifyContent="flex-end">
        {children}
      </Box>
    )}
    <Box height="60px" width="60px">
      <Spinner />
    </Box>
  </Box>
);

export default FallbackSpinner;
